<template>
  <div class="myRegistration">
        <h3 class="containner-title">{{$t("message.create_or_edit_training")}}</h3>
        <div class="card-body border" style="background-color: #f1f1f1;">
            <form class="form" v-on:submit.prevent>
              <div class="mb-3">
                <label for="first-name" class="form-label">{{$t("message.business_type")}}</label>
                <select
                    class="form-select"
                    v-model="formTraining.type"
                  >
                    <option selected>ជ្រើរើសប្រភេទអាជីវកម្ម...</option>
                    <option value="1">{{$t("message.stock_business")}}</option>
                    <option value="4">{{$t("message.found")}}</option>
                    <option value="2">{{$t("message.derivative_business")}}</option>
                </select>
              </div>
              <div class="mb-3">
                <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="training"
                      value="1"
                      v-model="formTraining.apply_for"
                      name="trainingType"
                    />
                    <label class="form-check-label" for="training">
                      វគ្គបណ្តុះបណ្តាល
                      និងការប្រឡងសម្រាប់បុគ្គលត្រូវទទួលស្គាល់គុណវុឌ្ឍិ (New)
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      value="2"
                      id="cpe"
                      name="trainingType"
                      v-model="formTraining.apply_for"
                    />
                    <label class="form-check-label" for="cpe">
                      កម្មវិធីអប់រំវិជ្ជាជីវៈបន្ត (CPE)
                    </label>
                  </div>
              </div>
              <div class="mb-3">
                <label for="title" class="form-label">{{$t("message.title")}}</label>
                <input type="input" 
                  v-model="formTraining.title"
                  class="form-control" 
                  id="title" 
                  placeholder="Title">
              </div>
              <div class="mb-3 row">
                <div class="col">
                    <label for="startDate" class="form-label">{{$t("message.start_date")}}</label>
                    <input
                      v-maska="'##/##/####'"
                      v-model="formTraining.start_date"
                      class="form-control"
                      id="startDate"
                      placeholder="Start Date"
                      aria-label="startDate"
                      aria-describedby="startDate"
                    />
                </div>
                <div class="col">
                    <label for="endDate" class="form-label">{{$t("message.end_date")}}</label>
                    <input
                      v-maska="'##/##/####'"
                      v-model="formTraining.end_date"
                      class="form-control"
                      id="endDate"
                      placeholder="End Date"
                      aria-label="endDate"
                      aria-describedby="endDate"
                    />
                </div>
              </div>
              <div class="mb-3">
                <label for="examDate" class="form-label">{{$t("message.examination_date")}}</label>
                    <input
                      v-maska="'##/##/####'"
                      v-model="formTraining.exam_date"
                      class="form-control"
                      id="examDate"
                      placeholder="Exam Date"
                      aria-label="examDate"
                      aria-describedby="examDate"
                    />
              </div>
              <div class="mb-3 row">
                <div class="col">
                    <label for="startTime" class="form-label">{{$t("message.start_time")}}</label>
                    <input
                      class="form-control"
                      placeholder="Start Time"
                      aria-label="startTime"
                      aria-describedby="startTime"
                      v-model="formTraining.start_time"
                      v-maska="'##:##'"
                    />
                </div>
                <div class="col">
                    <label for="endTime" class="form-label">{{$t("message.end_time")}}</label>
                    <input class="form-control"
                      placeholder="End Time"
                      aria-label="endTime"
                      aria-describedby="endTime"
                      v-model="formTraining.end_time"
                      v-maska="'##:##'"/>
                </div>
              </div>
              <div class="mb-3">
                <label for="description" 
                  class="form-label">{{$t("message.description")}}</label>
                <textarea class="form-control" 
                  id="description" 
                  rows="3" 
                  v-model="formTraining.description"
                  placeholder="Description">
                </textarea>
              </div>
              <div class="mb-3 text-end">
                <router-link type="button" 
                  class="btn btn-secondary m-1" 
                  :to="{ name: 'adminTrainingGroup' }">
                  <i class="fas fa-arrow-left"></i>
                  {{$t("message.back")}}
                </router-link>
                <button class="btn btn-primary" @click="saveData">
                  <i class="fas fa-save"></i> {{$t("message.save")}}
                </button>
              </div>
            </form>
        </div>
  </div>
</template>
<script>
import axios from "@/axios";
export default {
  data() {
    return {
      formTraining: {
        id: 0,
        title: "",
        apply_for: "",
        description: "",
        type: "",
        start_date: "",
        end_date: "",
        exam_date: "",
        start_time: "",
        end_time: ""
      }
    };
  },
  computed: { },
  methods: {
    showLoader() {
      return this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    updateData(resData,type=1){
      console.log('update date',resData);
      if(type==1){
        const data = this.$store.getters.getDataTraining;
         const updatedata = [...data,{...resData}];
        this.$store.commit('changeDataTraining',updatedata);
      }else{
        const data = this.$store.getters.getDataTraining;
        if(data.length>0){
          const updatedata = data.map(el => el.id == resData.id ? {...resData} : el);
          this.$store.commit('changeDataTraining',updatedata);
        }
      }
    },
    async loadData(){
      let loader = this.showLoader();
      const trainingId = this.$route.params.id ? this.$route.params.id : '';
      const respone = await axios.get("training-group/"+trainingId, {
        headers: {
          Authorization: "Bearer " + this.$store.getters.getAuthToken
        }
      });
      if (respone.status == 200) {
        console.log("this data:",respone.data);
        this.formTraining = respone.data.data;
      }
      loader.hide();
    },
    async saveData(){
      this.$swal
        .fire({
          title: "តើអ្នកចង់រក្សាទុកមែនទេ?",
          showCancelButton: true,
          confirmButtonText: `យល់ព្រម`,
          cancelButtonText: `បោះបង់`
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let loader = this.showLoader();
            if(this.$route.params.id){
              const respone = await axios.put("training-group/"+this.$route.params.id, this.formTraining, {
                headers: {
                  Authorization: "Bearer " + this.$store.getters.getAuthToken
                }
              });
              this.updateData(respone.data.data,0);
              loader.hide();
            }else{
              const respone = await axios.post("training-group", this.formTraining, {
                headers: {
                  Authorization: "Bearer " + this.$store.getters.getAuthToken
                }
              });
              loader.hide();
              if (respone.status == 200 || respone.status == 201) {

                console.log("It is data respone: ",respone.data.data);
                this.updateData(respone.data.data,1);
                this.$router.push(
                  { 
                    name: "showAdminTrainingGroup", 
                    params:{id: respone.data.data.id} 
                  }
                );
              }
            }
          }
        });
    }
  },
  created() {
    if(this.$route.params.id){
      this.loadData();
    }
  },
  mounted() {
   
  }, components: {
   
  }
};
</script>
<style scoped>

div.content {
  margin-left: 200px;
  padding: 25px;
  height: auto;
  margin-top: 0;
}
</style>
